import icon from './google_analytics.png.js';
import template from './google_analytics_graph_widget_view.html';
import templateMaxView from './google_analytics_graph_widget_max.html';
import templateReportView from './google_analytics_widget_report.html';

angular.module('MW.InsDashboard.googleAnalyticsWidget', [
    'DashboardChartConfigService',
    'MW.Framework.TranslationService',
    'MW.Dashboard.DashboardWidgetService',
    'MW.Dashboard.DashboardStateService',
    'MW.InsDashboard.insightsBackendService',
    'MW.Framework.GeoService',
    'MW.InsDashboard.InsWidgetConfigService',
    'MW.Framework.CoreCommon',
    'MW.InsDashboard.ChartDataService',
    'MW.InsDashboard.ChartService',
    'MW.InsDashboard.TransformSov',
    'MW.InsDashboard.InsightsDataMaps',
    'MW.InsDashboard.WidgetController',
    'MW.Configuration',
    'MW.Framework.googleAnalyticsHighchart',
    'MW.InsDashboard.GoogleAnalyticsService',
    'MW.Framework.Breadcrumb',
    'MW.Framework.DialogService'
])
.directive('googleAnalyticsWidget', [
    'DashboardChartConfigService',
    'translationService',
    'DashboardWidgetService',
    'DashboardStateService',
    'insightsBackendService',
    '$filter',
    '$q',
    'GeoService',
    'InsWidgetConfigService',
    'CoreCommon',
    'ChartDataService',
    'ChartService',
    'CoreChartObject',
    'TransformSov',
    'InsightsDataMaps',
    'GoogleAnalyticsService',
    '$routeParams',
    '$location',
    '$controller',
    'Breadcrumb',
    'DialogService',
    'DASHBOARD_LEGACY_VIEW_PATH',
    function(DashboardChartConfigService, translationService,  DashboardWidgetService, DashboardStateService, insightsBackendService, $filter, $q, GeoService, InsWidgetConfigService, CoreCommon, ChartDataService, ChartService, CoreChartObject, TransformSov, InsightsDataMaps, GoogleAnalyticsService, $routeParams, $location, $controller, Breadcrumb, DialogService, DASHBOARD_LEGACY_VIEW_PATH){

    var googleAnalyticsWidget = DashboardWidgetService.getWidget('google-analytics-widget');

    var googleAnalyticsWidgetController = function($scope, $routeParams){
        $controller('WidgetController', {$scope: $scope, $routeParams: $routeParams, $location: $location});//inject the scope and use the basic widget controller
    };



    var googleAnalyticsWidgetLink = function(scope, element) {

        scope.serviceError = false;
        scope.hasGoogleAccountError = false;
        scope.hasGooglePropertyError = false;

        var customData = {
            tooltip: {
                formatter: function(event) {
                    if(scope.widget.settings.dateComparison) {
                        if(this.points.length > 1)
                            var deltaPercent = ((this.points[0].point.y - this.points[1].point.y) / this.points[1].point.y) * 100;
                        var s = '<div class="comparison-tooltip">';
                        $.each(this.points, function(i, point) {
                            s += '<div class="date"><b>' + $filter('mwConvertDateToUserTimezone')(point.point.date, 'fullDate')  + '</b></div>'
                            + '<div><div class="point" style="color:'+ point.point.series.color +'">\u25CF</div>'
                            + '<div class="googleAnalytics">' + translationService.getLocalizedString('Count') + ' (#): ' + ': </div>'
                            + '<div class="googleAnalytics"><b>' + Highcharts.numberFormat(point.point.y)
                            + '</b></div><div class="clearFix"></div></div>';
                        });
                        if(this.points.length > 1 && this.points[1].point.y > 0)
                            s += '<div class="change">'
                             + translationService.getLocalizedString('dashboard-widgets__graph-tooltip-change') + Highcharts.numberFormat(deltaPercent) + '%'
                             + '</div>';
                        s += '</div>'
                        return s;
                    } else {
                        var searchName = (this.point.name) ? this.point.name : this.series.name;
                        var output = '<b>'+ searchName + '<br/>';
                        output += translationService.getLocalizedString('Count') + ' (#): ' + Highcharts.numberFormat(Math.abs(this.point.y), 0) + ' / ' + Highcharts.numberFormat(this.point.percent) + '%';
                        if(this.point.indx > 0){
                            //get previous percentage
                            var previousData = this.series.data[this.point.indx - 1].y;
                            if(previousData > 0) { // GYDA-4537 - Cannot calculate a change percentage if your previous value is 0
                                var deltaPercent = ((this.point.y - previousData) / previousData)*100;
                                output += '<br/>' + translationService.getLocalizedString('dashboard-widgets__graph-tooltip-change') + ' ' + Highcharts.numberFormat(deltaPercent) +'%';
                            }
                        }
                        return output;
                    }
                }
            }
        };

        var chartOverrides = {
            max:customData
        };

        var settingsOverides = {
            fetchDataForPreviousRange: scope.widget.settings.dateComparison,
            yAxisTitle: 'Volume'
        };

        scope.$on('$locationChangeSuccess', function onCoreBreadcrumbLocationChangeSuccess(event, newVal, oldVal) {
            var oldParams = getRequestParams(oldVal),
                newParams = getRequestParams(newVal),
                breadcrumbString,
                breadcrumbArray,
                displayDate;

            updateBreadcrumb(newParams.date, newParams.clickedAxis);

            if(oldParams.clickedAxis !== undefined && newParams.clickedAxis === undefined) {
                // Drilling OUT of a datapoint selection.  In the scenario, we don't have the benefit of
                // the action triggering a content stream refresh, so we have to trigger it ourselves here.
                // Calling the drilldown function in this way essentially triggers a reset
                scope.documentRequest.refererUrls = null;
                InsWidgetConfigService.dateGranularityDrilldown(false, undefined, scope);
            } else if (
                (newParams.clickedAxis !== undefined && oldParams.clickedAxis === undefined) ||
                (newParams.clickedAxis !== undefined && oldParams.clickedAxis !== undefined &&
                    ((newParams.clickedAxis !== oldParams.clickedAxis) || (newParams.date !== oldParams.date)))) {
                // In this case, the user probably used the browser's Forward button to go back to a drilldown.
                // Since we don't have the benefit of a click trigger, we need to do it manually here

                var uriDecodedDate = moment(decodeURIComponent(newParams.date));
                filterContentStream(uriDecodedDate);
            }

            if (newVal.indexOf('&drilled&') > -1) {
                if(newParams.date) {
                    displayDate = moment(newParams.date.split('T')[0]);
                    breadcrumbString = scope.breadcrumbs[scope.breadcrumbs.length - 1].name;
                    breadcrumbArray = breadcrumbString.split(',');
                    if (scope.dateBreakoutsMonth) {
                        updateLastBreadcrumb(breadcrumbArray[0] + ', ' + displayDate.format("MMM") + ' ' + displayDate.year());
                    }
                    else if (scope.dateBreakoutsQuarter) {
                        updateLastBreadcrumb(breadcrumbArray[0] + ', Q' + displayDate.quarter() + ' ' + displayDate.year());
                    }
                    else if (scope.dateBreakoutsYear) {
                        updateLastBreadcrumb(breadcrumbArray[0] + ', ' + displayDate.year());
                    }
                }
            }
        });

        var updateBreadcrumb = function updateBreadcrumb(date, clickedAxis) {
            var dashboardPath,
                widgetPath,
                selectionTitle = '',
                dashboardMode = $location.path().indexOf('/dashboard/viewer') !== -1 ? '/dashboard/viewer/' : '/dashboard/builder/';

            scope.breadcrumbs =[];
            scope.breadcrumbs = [Breadcrumb.build({
                name: 'Analyze',
                link: '/analyze/home',
                isClickable: false
            })];
            dashboardPath = '/dashboard/viewer/' + scope.dashboard._id;

            if(scope.searches && scope.searches.length === 1) {
                selectionTitle += date ? moment(date).format('MMM Do') : '';
            } else {
                selectionTitle += clickedAxis ? decodeURI(clickedAxis) : '';
                selectionTitle += date ? ', ' + moment(date).format('MMM Do') : '';
            }

            scope.breadcrumbs.push(Breadcrumb.build({name:scope.dashboard.title, link:dashboardPath }));
            if(selectionTitle === '') {
                var mypath = '/dashboard/viewer/'+scope.dashboard._id,
                    subCrumbs = [],
                    myNewPath,
                    subCrumbVal;

                if(scope.dashboard.containers[0].widgets.length > 1) {
                    Object.keys(scope.dashboard.containers[0].widgets).forEach(function(key){
                        myNewPath = dashboardMode + scope.dashboard._id + '/' + scope.dashboard.containers[0].widgets[key].id + '?editMode=false';
                        subCrumbVal = {
                            name: scope.dashboard.containers[0].widgets[key].title,
                            link: myNewPath,
                            isClickable: function isClickable() { return true; }
                        };

                        subCrumbs.push(subCrumbVal);
                    });
                }
                scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title, subCrumbs:subCrumbs}));
            } else {
                widgetPath = dashboardMode + scope.dashboard._id + '/' + scope.widget.id + '?editMode=false';
                scope.breadcrumbs.push(Breadcrumb.build({name:scope.widget.title, link: widgetPath}));
                scope.breadcrumbs.push(Breadcrumb.build({name:selectionTitle}));
            }
        };

        var getRequestParams = function getRequestParams(url) {
            var params = {};
            var searchStr = url.split("?")[1];
            if(searchStr !== undefined) {
                var paramsStr = searchStr.split("&");
                for(var key in paramsStr) {
                    params[paramsStr[key].split("=")[0]] = paramsStr[key].split("=")[1];
                }
            }
            return params;
        };

        var updateLastBreadcrumb = function updateLastBreadcrumb(lastBreadcrumb) {
            scope.breadcrumbs[scope.breadcrumbs.length - 1].name = lastBreadcrumb;
        };

        var chartConfiguration = {
            insightsService: 'statisticServiceDateHistogram',
            insightsObject : 'dateHistograms',
            charts:{
                spline:{ chart:ChartService.line,transform:TransformSov.spline, dataMap:InsightsDataMaps.datamapDateVolume, custom: chartOverrides, customSettings:settingsOverides},
                donut:{ chart:ChartService.donut,transform:TransformSov.donut, dataMap:InsightsDataMaps.datamapDateVolume},
                column:{ chart:ChartService.column,transform:TransformSov.column, dataMap:InsightsDataMaps.datamapDateVolume, custom: chartOverrides},
                areaspline: {chart: ChartService.area, transform: TransformSov.areaspline, dataMap: InsightsDataMaps.datamapDateVolume, custom: chartOverrides},
                table: {chart:{},transform:TransformSov.table,dataMap:InsightsDataMaps.datamapDateVolume}
            },
            table: {
                enabled: true,
                rowTitle: translationService.getLocalizedString('Date'),
                summaryTitle: translationService.getLocalizedString('Total'),
                titleField: 'name',
                countField: 'volume',
                percentField: 'sov',
                tooltip: function sov_table_tooltip(datapoint){
                    return translationService.getLocalizedString('Volume: ') + datapoint.volume;
                },
                customRowTitleSort: true
            }
        };

        if ( scope.widget.settings.dateRange && scope.widget.settings.dateRange.absoluteEndDate && scope.widget.settings.dateRange.absoluteStartDate && (moment(scope.widget.settings.dateRange.absoluteEndDate).diff(moment(scope.widget.settings.dateRange.absoluteStartDate), 'days') + 1) > 92 ) {
            scope.widgetIsLoading = false;
            scope.serviceError = true;
            var invalidDateRangeErrorMessage = translationService.getLocalizedString('google-analytics-widget__invalid-date-range-dialog--message', {days: '90'});
            var errorMessageTitle = scope.widget.title + ' - ' + translationService.getLocalizedString('google-analytics-widget__invalid-date-range-dialog--title');
            DialogService.alert(invalidDateRangeErrorMessage, errorMessageTitle);
        } else {
            if(scope.widget.settings.selectedGoogleAnalyticsSource) {
                var accountId = scope.widget.settings.selectedGoogleAnalyticsSource.accountId,
                    webPropertyId = scope.widget.settings.selectedGoogleAnalyticsSource.webPropertyId,
                    webProfileId = scope.widget.settings.selectedGoogleAnalyticsSource.viewId;

                var refreshCache = Date.now();

                GoogleAnalyticsService.getTimezone(accountId, webPropertyId, webProfileId, refreshCache).then(function (result) {
                    chartConfiguration.timezoneOverride = result.data.timezone;
                    scope.widget.settings.timezoneOverride = result.data.timezone;

                    return chartConfiguration;
                }).then(function(chartConfiguration) {
                    scope.initWidget(chartConfiguration);
                }).catch(function (error) {
                    scope.hasGoogleAccountError = true;
                    scope.hasGooglePropertyError = false;
                    chartConfiguration.timezoneOverride = 'UTC';
                    scope.widget.settings.timezoneOverride = 'UTC';
                    scope.initWidget(chartConfiguration);
                });
            } else {
                GoogleAnalyticsService.hasGoogleAccount().then(function handleUserProfileResponse(profile) {
                    if(!profile.data) {
                        scope.hasGoogleAccountError = true;
                        scope.hasGooglePropertyError = false;
                    } else {
                        scope.hasGoogleAccountError = false;
                        scope.hasGooglePropertyError = true;
                    }
                }).catch(function handleErrorReponse() {
                    scope.hasGoogleAccountError = true;
                    scope.hasGooglePropertyError = false;
                });
                chartConfiguration.timezoneOverride = 'UTC';
                scope.widget.settings.timezoneOverride = 'UTC';
                scope.initWidget(chartConfiguration);
            }
        }

        var updateLocationURL = function updateLocationURL(queryParams) {
            var maxPath,
                editMode = $routeParams.editMode || false;
            if($location.path().indexOf('/dashboard/index') === 0) {
                maxPath = '/dashboard/viewer/'+DashboardStateService.getDefaultDashboard()+'/' + $scope.widget.id;
            } else if($routeParams.dashboardId && $routeParams.dashboardId != 'current' && $routeParams.dashboardId != 'new'){
                maxPath = $location.path();
            } else {
                maxPath = '/dashboard/'+($location.path().indexOf('builder') === -1?'viewer':'builder')+'/'+(DashboardStateService.currentDashboard._id || 'current') + '/' + $scope.widget.id;
            }

            if(!$routeParams.drilled) {
                queryParams['drilled'] = true;
            }

            var urlQuery = {
                editMode:editMode
            };
            for(var prop in queryParams) {
                urlQuery[prop] = queryParams[prop]
            }

            $location.path(maxPath).search(urlQuery);
        };

        scope.internalDrillDown = function(_, date, xPosition){
            scope.widget.clickedxPosition = xPosition;
            if(!scope.isMaximized || !date) {
                return;
            }

            var startDate = moment(date);


            switch (scope.widget.settings.dateRange.granularity) {
                case 'WEEK':
                case 'MONTH':
                    if (moment(scope.widget.settings.dateRange.absoluteStartDate) > startDate) {
                        startDate = moment(scope.widget.settings.dateRange.absoluteStartDate);
                    }
                    break;
            }

            var queryParams = {
                drilled: true,
                date: startDate.tz(scope.widget.settings.timezoneOverride).format(),
                clickedAxis: translationService.getLocalizedString('google-analytics-widget__graph-legend-label--referred-sessions')
            };

            updateLocationURL(queryParams);
        };

        var filterContentStream = function (date) {
            if (!scope.queryRequestSettings) {
                scope.queryRequestSettings = {};
            }

            var endDate, startDate;

            switch (scope.widget.settings.dateRange.granularity) {
                case 'DAY':
                    endDate = startDate = date;
                    break;
                case 'WEEK':
                    startDate = date;

                    endDate = startDate.clone();
                    endDate.tz(scope.widget.settings.timezoneOverride).endOf('isoWeek');

                    if (moment(scope.widget.settings.dateRange.absoluteEndDate) < endDate) {
                        endDate = moment(scope.widget.settings.dateRange.absoluteEndDate);
                    }

                    break;
                case 'MONTH':
                    startDate = date;

                    endDate = startDate.clone();
                    endDate.tz(scope.widget.settings.timezoneOverride).endOf('month');

                    if (moment(scope.widget.settings.dateRange.absoluteEndDate) < endDate) {
                        endDate = moment(scope.widget.settings.dateRange.absoluteEndDate);
                    }

                    break;
            }

            GoogleAnalyticsService.getReferers(scope.widget.settings.selectedGoogleAnalyticsSource.viewId, startDate.tz(scope.widget.settings.timezoneOverride).format('YYYY-MM-DD'), endDate.tz(scope.widget.settings.timezoneOverride).format('YYYY-MM-DD')).then(function result(data) {
                scope.documentRequest.refererUrls = data.data;

                scope.fromDate = moment(scope.toDate).tz(scope.widget.settings.timezoneOverride).startOf('month').add(-5, 'months');

                InsWidgetConfigService.dateGranularityDrilldown(false, undefined, scope);
            });

        };

        scope.fetchData = function fetchData() {
            scope.initSettings();

            if(!scope.readyToQuery) {
                return;
            }

            scope.chartData = null;
            scope.widgetIsLoading = true;

            var viewName = 'user';

            if(scope.isReport){
                viewName = 'report';
            } else if(scope.isMaximized){
                viewName = 'max';
            }

            var chartBasics = {
                type: scope.graphType,
                view: viewName,
                percent : scope.percentageMode,
                animate:scope.isReport ? false : InsWidgetConfigService.getChartAnimationStatus(scope.widget.id+scope.isMaximized),
                reportType: scope.reportType
            };

            if(scope.inputs){
                scope.chartDataObject.inputs = scope.inputs;
                chartBasics.inputs = scope.inputs;
            } else if(scope.searches){
                chartBasics.searches = scope.searches;
            }

            if(typeof chartConfiguration.charts[scope.graphType].customSettings !== 'undefined'){
                chartBasics = angular.extend(chartBasics, chartConfiguration.charts[scope.graphType].customSettings);
            }

            //set up our chart data object (the first part of this is handled in ins_widget_config_service)
            scope.chartDataObject.percentageMode = scope.percentageMode;
            scope.chartDataObject.dataMap = chartConfiguration.charts[scope.graphType].dataMap;
            scope.chartDataObject.chartTransformFunction = chartConfiguration.charts[scope.graphType].transform;

            if(chartConfiguration.AveValue) {
                scope.chartDataObject.AveValue = chartConfiguration.AveValue;
            }
            if(chartConfiguration.previousDateEnd && chartConfiguration.previousDateStart)  {
                scope.chartDataObject['previousDateStart'] = chartConfiguration.previousDateStart;
                scope.chartDataObject['previousDateEnd'] = chartConfiguration.previousDateEnd;
            }
            if(chartConfiguration.timezoneOverride) {
                scope.chartDataObject.timezoneOverride = chartConfiguration.timezoneOverride;
            }

            if(scope.graphType == 'table'){
                scope.chartDataObject.callback = function tableCallback(chartRequestData){
                    scope.tableSettings.data = chartRequestData.table;
                    if(scope.chartDataObject.percentageMode === true){
                        scope.tableSettings.displayField = scope.tableSettings.percentField;
                    }else{
                        scope.tableSettings.displayField = scope.tableSettings.countField;
                    }
                    scope.tableSettings.summary = chartRequestData.summary;
                    scope.widgetIsLoading = false;
                };
            } else {
                scope.chartDataObject.callback = function chartDataCallback (chartRequestData) {

                    scope.newChartData = chartRequestData;
                    scope.chartData = new CoreChartObject(chartBasics, scope.newChartData);

                    var custom = (angular.isUndefined(chartConfiguration.charts[scope.graphType].custom) || angular.isUndefined(chartConfiguration.charts[scope.graphType].custom[chartBasics.view])) ? null : chartConfiguration.charts[scope.graphType].custom[chartBasics.view];
                    var customSettings = angular.isUndefined(chartConfiguration.charts[scope.graphType].customSettings) ? null : chartConfiguration.charts[scope.graphType].customSettings;

                    var chartConfig = {
                        view: chartBasics.view,
                        percentageMode: scope.percentageMode,
                        drillDown: scope.internalDrillDown,
                        data: scope.chartData,
                        custom: custom,
                        dataLabels: scope.labelVisibility,
                        customSettings: customSettings,
                        reportType: (scope.widgetView === 'report' || scope.widgetView === 'email') ? scope.widgetView : 'none'
                    };

                    scope.chartData = CoreCommon.mergeRecursive(scope.chartData, chartConfiguration.charts[scope.graphType].chart(chartConfig));
                    scope.widgetIsLoading = false;

                    if($routeParams.inputId || $routeParams.date) {
                        updateBreadcrumb($routeParams.inputId, $routeParams.date);
                    }
                };
            }

            //make request and transform results
            scope.chartDataObject.queryParameters.agents = [];
            scope.chartDataObject.queryParameters.rssFeeds = [];
            scope.chartDataObject.queryParameters.tags = [];
            scope.chartDataObject.queryParameters.dateStart = scope.chartDataObject.fromDate;
            scope.chartDataObject.queryParameters.dateEnd = scope.chartDataObject.toDate;

            if (DashboardStateService.refreshCache) {
                scope.chartDataObject.queryParameters.refreshCache = true;
                DashboardStateService.refreshCache = false;
            }

            var fetchAllDataPromises = [];
            fetchAllDataPromises.push(ChartDataService.fetchAllData(scope.chartDataObject, scope.$id));

            var startDate = scope.fromDate;
            var endDate = scope.toDate;

            var granularity = scope.widget.settings.dateRange.granularity;
            var agent;
            var tag;

            if (scope.widget.settings.inputs && scope.widget.settings.inputs.length > 0) {
                if (scope.widget.settings.inputs[0].inputType === 'tags') {
                    tag = scope.widget.settings.inputs[0].id;
                } else {
                    agent = scope.widget.settings.inputs[0].id;
                }
            }

            refreshCache = null;
            if (scope.isMaximized) {
                refreshCache = Date.now();
            }

            var viewId = null;
            if (scope.widget.settings.selectedGoogleAnalyticsSource) {
                viewId = scope.widget.settings.selectedGoogleAnalyticsSource.viewId;
            }

            var timezoneOverride = scope.widget.settings.timezoneOverride;
            var shouldUseAllSessions = scope.widget.settings.selectedGoogleAllSessions || false;

            fetchAllDataPromises.push(GoogleAnalyticsService.getSessions(viewId, timezoneOverride, startDate, endDate, agent, granularity, shouldUseAllSessions, tag, refreshCache));
            $q.all(fetchAllDataPromises).then(function (response) {
                scope.widget.matchedUrlList = response[1].matchedUrlList;
                scope.chartData.sessions = response[1];
                scope.chartData = JSON.parse(JSON.stringify(scope.chartData));
            }).catch(function(error) {
                scope.widgetIsLoading = false;
                scope.serviceError = true;
            });

            // Run our updating function when we recieve an update notification from a widget higher in the scope tree.
            scope.$on('widgetFiltersUpdated', function widgetFiltersUpdated() {
                scope.graphType = getDefaultChartTypeFromSettings();
                scope.fetchData();
            });
        };

        if ($routeParams.date || $routeParams.clickedAxis) {
            updateBreadcrumb($routeParams.date, $routeParams.clickedAxis);
            filterContentStream(moment($routeParams.date));
        }
    };
    return new WidgetDirective(googleAnalyticsWidget, googleAnalyticsWidgetLink, googleAnalyticsWidgetController);
}])
.run(['DashboardWidgetService', 'translationService', 'CoreCommon', 'InsWidgetConfigService', 'DASHBOARD_LEGACY_URL', function (DashboardWidgetService, translationService, CoreCommon, InsWidgetConfigService, DASHBOARD_LEGACY_URL) {
    DashboardWidgetService.register({
        name: translationService.getLocalizedString('google-analytics-widget__add-widget--title'),
        app: 'ins_dashboard',
        description: translationService.getLocalizedString('google-analytics-widget__add-widget--description'),
        directive: 'google-analytics-widget',
        icon,
        defaultSettings: {
            'width': 'third',
            'title': 'Title',
            'description': '',
            'maxAgents': 1
        },
        displayOrder: 1,
        allowExport: true,
        availableExportTypes: ['PDF_EXPORT', 'PNG_EXPORT'],
        availableSettings: ['dateRange', 'dateBreakouts', 'title', 'googleAnalyticsSources', 'news','social','broadcast','rss','tags', 'labelVisibility', 'googleAnalyticsAllSessions'],
        availableChartTypes:[{name:'Line',id:'spline'}],
        availableDateBreakouts: [{
            name: 'Day',
            id: 'DAY'
        }, {
            name: 'Week',
            id: 'WEEK'
        }, {
            name: 'Month',
            id: 'MONTH'
        }],
        requiredSettings: ['dateRange'],
        getDefaultChartType: function() {
            if (CoreCommon.isUsable(this.settings.searchIds) && this.settings.searchIds.length > 1)
                return this.availableChartTypes[1];
            else
                return this.availableChartTypes[0];
        },
        hasRequiredSettings: function(){
            var _widget = this,
                hasInput = InsWidgetConfigService.hasSelectedAnInput(_widget);

            return (hasInput);
        },
        template,
        templateMaxView,
        templateReportView
    });
}]);
